<template>
  <div class="animated fadeIn">
    <b-container>
       <b-row align-h="center">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header text-center bg-primary">{{$t('HLMUsers')}}</div>
            <div class="card-body">
         <div v-if="loading">
        <BlockUI :message="blockuimsg"></BlockUI>
      </div>
      <b-row>
        <b-button-toolbar key-nav>
          <b-button-group class="mx-1">
             <b-button @click="onNew" variant="info"><strong>{{$t('New')}}</strong></b-button>
             <b-button @click="onBulkResetConfirm" variant="warning" :disabled="selectedUserIds.length === 0" class="ml-2">
               <strong><i class="fa fa-key"></i> {{$t('BulkResetPassword')}} ({{selectedUserIds.length}})</strong>
             </b-button>
          </b-button-group>
        </b-button-toolbar>
      </b-row>
      <b-row>
        &nbsp;
      </b-row>
      <b-row>
       <b-col md="6">
              <b-form-group label-cols-sm="2" :label="$t('Filter')" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" :placeholder="$t('TypeToSearch')"></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clean')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-cols-sm="3" :label="$t('RowPerPage')" class="mb-0">
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-form-group>
            </b-col>

            <br /><br />
            <b-table responsive
                striped
                hover
                small
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered">
          <template slot="HEAD_select" slot-scope="data">
            <b-form-checkbox v-model="allSelected" @change="toggleSelectAll"></b-form-checkbox>
          </template>
          <template slot="select" slot-scope="row">
            <b-form-checkbox v-model="selectedUserIds" :value="row.item.id"></b-form-checkbox>
          </template>
          <template slot="actions" slot-scope="row">
            
          <b-button-group class="mx-1">
            <b-button size="sm" @click="onEdit(row.item, row.index, $event.target)" class="mr-1">
              {{$t('Edit')}}
            </b-button>
            <b-button size="sm" @click="onDelete(row.item, row.index, $event.target)" class="mr-1">
              {{$t('Delete')}}
            </b-button>
            <b-button size="sm" @click="onResetPwd(row.item, row.index, $event.target)" class="mr-1 nowrap" variant="outline-warning">
              {{$t('ResetPassword')}}
            </b-button>
            <b-button size="sm" @click="onVs(row.item, row.index, $event.target)" class="mr-1 nowrap">
              {{$t('ValidationService')}}
            </b-button>            
            </b-button-group>
        
          </template>
        </b-table>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"></b-pagination>
        </b-col>
      </b-row>
              </div>
          </div>
        </div>
      </b-row>
    </b-container>

    <b-modal ref="mdlUsers" :title="selectedItem.Id == null ? $t('UserAdd') : $t('UserEdit')">
      <b-form @submit.stop.prevent="onSubmit">
      <b-container>
        <b-form-group id="idGroup"
                      label="Id:"
                      label-for="inpID"
                      :description="$t('IDForUser')">
          <b-form-input id="inpID"
                        v-model="selectedItem.Id"
                        readonly></b-form-input>
        </b-form-group>

        <b-form-group id="nombreGroup" :label="$t('Name')" label-for="inpNombre">
          <b-form-input id="inpNombre"
                        v-model="$v.selectedItem.Nombre.$model"
                        :placeholder="$t('TypeAName')"
                        :state="$v.selectedItem.Nombre.$dirty ? !$v.selectedItem.Nombre.$error : null"
                        aria-describedby="nombre-feedback"></b-form-input>
          <b-form-invalid-feedback id="nombre-feedback">
             {{$t('RequiredField')}}
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="emailGroup" label="Email:" label-for="inpEmail">
          <b-form-input id="inpEmail" type="email"
                        v-model="$v.selectedItem.Email.$model"
                        :placeholder="$t('TypeAnEmail')"
                        :state="$v.selectedItem.Email.$dirty ? validEmail($v.selectedItem.Email.$model) : null"
                        aria-describedby="Email-feedback"></b-form-input>
          <b-form-invalid-feedback id="Email-feedback">
              {{$t('RequiredField')}}
            </b-form-invalid-feedback>
        </b-form-group>

         <b-form-group id="rolGroup" label="Rol:" label-for="inpRol">
               <b-form-select id="inpRol" v-model="$v.selectedItem.Ref_Rol.$model" class="mb-3"
                              :options="roles"
                              value-field="id"
                              text-field="nombre"
                              :state="$v.selectedItem.Ref_Rol.$dirty ? !$v.selectedItem.Ref_Rol.$error : null"
                              aria-describedby="Ref_Rol-feedback">
              <template slot="first">
                    <option :value="null" disabled>{{$t('SelectAnOption')}}</option>
              </template>
               </b-form-select>
            <b-form-invalid-feedback id="Ref_Rol-feedback">
          {{$t('RequiredField')}}
        </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="paisGroup" :label="$t('Country')" label-for="inpPais">
               <b-form-select id="inpPais" v-model="$v.selectedItem.Ref_Pais.$model" class="mb-3"
                              :options="countries"
                              value-field="id"
                              text-field="nombre"
                              :state="$v.selectedItem.Ref_Pais.$dirty ? !$v.selectedItem.Ref_Pais.$error : null"
                              aria-describedby="Ref_Pais-feedback">
              <template slot="first">
                    <option :value="null" disabled>{{$t('CountrySelect')}}</option>
              </template>
               </b-form-select>
          <b-form-invalid-feedback id="Ref_Pais-feedback">
          {{$t('RequiredField')}}
        </b-form-invalid-feedback>
        </b-form-group>

        <b-row>
          <b-col cols="12" md="6">
            <b-form-checkbox id="bloqueado" v-model="selectedItem.bloqueado" name="bloqueado" unchecked-value="false"> {{$t('Blocked')}} </b-form-checkbox>
            <b-form-checkbox id="borrar_archivos" v-model="selectedItem.borrar_archivos" name="borrar_archivos" unchecked-value="false"> {{$t('AllowDeleteFiles')}} </b-form-checkbox>
          </b-col>
        </b-row>

        <b-form-group id="global_gap_tokenGroup" :label="$t('GlobalGAPToken')" label-for="inpGlobal_gap_token">
          <b-form-input id="inpGlobal_gap_token"
                        v-model="$v.selectedItem.global_gap_token.$model"></b-form-input>
        </b-form-group>

        <b-form-group id="vs_usuarioGroup" :label="$t('VsUser')" label-for="inpvs_usuario">
          <b-form-input id="inpvs_usuario"
                        readonly
                        v-model="selectedItem.vs_usuario"></b-form-input>
        </b-form-group>
      </b-container>
     </b-form>
      <div slot="modal-footer">
        <b-container>
          <b-row class="inline justify-content-end">
            <b-button variant="secondary"
                      size="sm"
                      @click="hideModal" class="mr-2">{{$t('Cancel')}}</b-button>
               <b-button type="submit"
                      size="sm"
                      variant="primary"
                      :disabled="$v.selectedItem.$invalid"
                      @click="onSave">{{$t('Save')}}</b-button>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <b-modal ref="mdlVs" :title="$t('ValidationService')">
       <b-form @submit.stop.prevent="onSubmit">
      <b-container>
        <b-form-group id="nombrevsGroup"
                      :label="$t('VsUser')"
                      label-for="nombrevsGroup">
          <b-form-input id="inpvsnombre"
                        v-model="selectedItem.vs_usuario"></b-form-input>
        </b-form-group>
        <b-form-group id="passwdvsGroup"
                      :label="$t('VsPassword')"
                      label-for="passwdvsGroup">
          <b-form-input id="inpvscontrasena"
                        v-model="selectedItem.vs_contrasena"></b-form-input>
        </b-form-group>
        
      </b-container>
        </b-form>
         <div slot="modal-footer">
        <b-container>
          <b-row class="inline justify-content-end">
            <b-button variant="secondary"
                      size="sm"
                      @click="hideModal" class="mr-2">{{$t('Cancel')}}</b-button>
                    
            <b-button type="submit"
                      size="sm"
                      variant="primary"
                      @click="onvsuserpassword">{{$t('Save')}}</b-button>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <b-modal ref="mdlResetPwd" :title="$t('ResetPassword')">
      <b-container>
        <p>{{$t('ResetPasswordNotice')}}</p>
        <b-form-group :label="$t('UserName')">
          <b-form-input v-model="selectedItem.Nombre" readonly></b-form-input>
        </b-form-group>
        <b-form-group label="Email:">
          <b-form-input v-model="selectedItem.Email" readonly></b-form-input>
        </b-form-group>
        <b-alert show variant="info" class="small">
          <i class="fa fa-info-circle"></i> Se generará una nueva contraseña segura que se mostrará en pantalla para que pueda proporcionársela al usuario. El usuario deberá cambiarla obligatoriamente al iniciar sesión.
        </b-alert>
      </b-container>
      <div slot="modal-footer">
        <b-container>
          <b-row class="inline justify-content-end">
            <b-button variant="secondary"
                      size="sm"
                      @click="hideModal" class="mr-2">{{$t('Cancel')}}</b-button>
            <b-button size="sm"
                      variant="warning"
                      @click="onResetPassword"><strong>{{$t('ConfirmResetPassword')}}</strong></b-button>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <b-modal ref="mdlShowGeneratedPassword" title="Contraseña Generada" header-bg-variant="primary" header-text-variant="white" no-close-on-backdrop>
      <b-container>
        <p class="mb-2">Se ha generado una contraseña segura para el usuario <strong>{{ generatedPasswordUser }}</strong>:</p>
        <p class="text-muted small">Copie esta clave y envíesela al usuario por chat o correo. El usuario deberá cambiarla obligatoriamente en su próximo inicio de sesión.</p>
        <b-input-group class="mt-3 mb-2">
          <b-form-input readonly :value="generatedPassword" style="font-family: monospace; font-size: 1.15rem; font-weight: bold; letter-spacing: 1px;"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="copyGeneratedPassword">
              <i class="fa fa-copy"></i> Copiar
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="primary" size="sm" @click="$refs.mdlShowGeneratedPassword.hide()">Entendido</b-button>
      </div>
    </b-modal>

    <ConfirmDialog ref="ConfirmDialog"></ConfirmDialog>
  </div>
</template>

<script>
    import ConfirmDialog from '../dialog/ConfirmDialog';
    import { validationMixin } from 'vuelidate'
    import { required, maxLength } from 'vuelidate/lib/validators'

    export default {
        components: {
            ConfirmDialog
        },
        data() {
          return {
              loading: false,
              blockuimsg: 'Cargando...',
              allSelected: false,
              selectedUserIds: [],
              generatedPassword: '',
              generatedPasswordUser: '',
              fields: {
                  select: {
                      label: '',
                      sortable: false,
                      thClass: 'text-center align-middle',
                      tdClass: 'text-center align-middle'
                  },
                  actions: {
                      label: 'Actions'
                  },
                  id: {
                      label: 'Id',
                      sortable: true
                  },
                  email: {
                      label: 'Email',
                      sortable: true
                  },
                  nombre: {
                      label: 'Nombre',
                      sortable: true
                  },
                  rol: {
                      label: 'Rol',
                      sortable: true
                  },
                  pais: {
                      label: 'País',
                      sortable: true
                  },
                  bloqueado: {
                      label: 'Bloqueado',
                      sortable: true
                  },
                  borrar_archivos: {
                      label: 'Permiso p/borrar archivos',
                      sortable: true
                  }, 
                  ref_rol: {
                      label: 'Ref_Rol',
                      sortable: true,
                      thClass: 'd-none',
                      tdClass: 'd-none'
                  },
                  ref_pais: {
                      label: 'Ref_Pais',
                      sortable: true,
                      thClass: 'd-none',
                      tdClass: 'd-none'
                  },
                  global_gap_token: {
                      label: 'Global GAP Token',
                      sortable: true
                  },                 
                  vs_usuario: {
                      label: 'Validation Service',
                      sortable: true
                  },                    
              },
              items: [],
              countries: [],
              roles: [],
              selectedItem: {
                  Id: null,
                  Nombre: null,
                  Email: null,
                  Ref_Pais: null,
                  Ref_Rol: null,
                  bloqueado: false,
                  global_gap_token: null,
                  vs_usuario: null,
                  vs_contrasena: null
              },
              totalRows: 1,
              currentPage: 1,
              perPage: 5,
              pageOptions: [5, 10, 15, 25, 50],
              sortBy: null,
              sortDesc: false,
              sortDirection: 'asc',
              filter: null,
          }
        },
        validations:
        {
            selectedItem: {
                Nombre: {
                    required,
                    maxLength: maxLength(250)
                },
                Email: {
                    required,
                    maxLength: maxLength(150)
                },
                Ref_Pais: {
                    required
                },
                Ref_Rol: {
                    required
                },
                global_gap_token: {
                    maxLength: maxLength(150)
                },                
            }
        },
        methods: {
            toggleSelectAll(checked) {
                if (checked) {
                    this.selectedUserIds = this.items.map(u => u.id);
                } else {
                    this.selectedUserIds = [];
                }
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            loadData() {
                this.loading = true;
                this.selectedUserIds = [];
                this.allSelected = false;
                this.$http.get('/api/users/list').then(
                    function (response) {
                        if (response.body.Ok) {
                            this.items = response.body.Data;
                            this.totalRows = this.items.length;
                            this.$http.get('/api/countries/list').then(
                                function (response) {
                                    this.countries = response.body.Data;
                                    this.$http.get('/api/roles/list').then(
                                        function (response) {
                                            this.roles = response.body.Data;
                                        });
                                });
                        }
                    },
                    (response) => {
                        if (!response.body.Ok) {
                            this.$toasted.show(response.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
                        }
                    });

                this.loading = false;
            },
            onNew() {
                this.$refs.mdlUsers.show();
                this.selectedItem.Id = null;
                this.selectedItem.Nombre = null;
                this.selectedItem.Email = null;
                this.selectedItem.Ref_Pais = null;
                this.selectedItem.Ref_Rol = null;
                this.selectedItem.bloqueado = false;
                this.selectedItem.borrar_archivos = false;
                this.selectedItem.global_gap_token = null;
                this.selectedItem.vs_usuario = null;
                this.selectedItem.vs_contrasena = null;
            },
            hideModal() {
                this.$refs.mdlUsers.hide();
                this.$refs.mdlResetPwd.hide();
                this.$refs.mdlVs.hide();
            },
            copyGeneratedPassword() {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(this.generatedPassword);
                } else {
                    const el = document.createElement('textarea');
                    el.value = this.generatedPassword;
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                }
                this.$toasted.show('Contraseña copiada al portapapeles', { theme: 'outline', type: 'success', duration: 3000 });
            },
            async onSave() {
                this.$v.selectedItem.$touch()
                if (this.$v.selectedItem.$anyError) {
                    return;
                }

                this.loading = true;

                let isNew = !this.selectedItem.Id || this.selectedItem.Id === -1;
                let userEmail = this.selectedItem.Email;

                let userData = {
                    id: this.selectedItem.Id || -1,
                    nombre: this.selectedItem.Nombre,
                    email: this.selectedItem.Email,
                    clave: null,
                    ref_pais: this.selectedItem.Ref_Pais,
                    ref_rol: this.selectedItem.Ref_Rol,
                    bloqueado: this.selectedItem.bloqueado,
                    borrar_archivos: this.selectedItem.borrar_archivos,
                    global_gap_token: this.selectedItem.global_gap_token,
                    vs_usuario: this.selectedItem.vs_usuario,
                    vs_contrasena: this.selectedItem.vs_contrasena,
                };
                try {
                    var response = await this.$http.post('/api/users/save', userData);
                    if (response.body.Ok) {
                        this.$refs.mdlUsers.hide();
                        this.loadData();
                        
                        if (response.body.Data && response.body.Data.GeneratedPassword) {
                            this.generatedPassword = response.body.Data.GeneratedPassword;
                            this.generatedPasswordUser = userEmail;
                            this.$refs.mdlShowGeneratedPassword.show();
                        } else {
                            this.$toasted.show(this.$t('RegistrationUpdatedSuccessfully'), { theme: 'outline', type: 'success', duration: 5000 });
                        }
                    }
                    else {
                        this.$toasted.show(this.$t('UpdatingRegistryError'), { theme: 'outline', type: 'error', duration: 5000 });
                    }
                }
                catch (e) {
                    var response = e;
                    if (!response.body.Ok) {
                        var errMsg = response.data && response.data.Data ? response.data.Data.Message : (response.body && response.body.Message ? response.body.Message : '');
                        this.$toasted.show(this.$t('UpdatingRegistryError') + " " + errMsg, { theme: 'outline', type: 'warning', duration: 8000 });
                    }
                }
                this.$refs.mdlUsers.hide();
                this.loading = false;
            },
            async onvsuserpassword() {
                this.loading = true;
                let userData = {
                    id: this.selectedItem.Id,
                    vs_usuario: this.selectedItem.vs_usuario,
                    vs_contrasena: this.selectedItem.vs_contrasena,
                };
                try {
                    var response = await this.$http.post('/api/users/vsuserpassword', userData);
                    if (response.body.Ok) {
                        this.$toasted.show(this.$t('PasswordUpdated'), { theme: 'outline', type: 'success', duration: 5000 });
                        this.$refs.mdlVs.hide();
                        this.loadData();
                    }
                    else {
                        this.$toasted.show(this.$t('UpdatingRegistryError'), { theme: 'outline', type: 'error', duration: 5000 });
                    }
                } catch (e) {
                  this.$toasted.show(this.$t('UpdatingRegistryError'), { theme: 'outline', type: 'error', duration: 5000 });
                }
                this.loading = false;
            },            
            async onResetPassword() {
                this.loading = true;
                let userEmail = this.selectedItem.Email;
                let userData = {
                    id: this.selectedItem.Id || -1,
                    nombre: this.selectedItem.Nombre,
                    email: this.selectedItem.Email,
                    clave: null,
                    ref_pais: null,
                    ref_rol: null,
                    global_gap_token: null,
                    vs_usuario: null,
                    vs_contrasena: null,
                };
                try {
                    var response = await this.$http.post('/api/users/resetpassword', userData);
                    if (response.body.Ok) {
                        this.$refs.mdlResetPwd.hide();
                        if (response.body.Data && response.body.Data.GeneratedPassword) {
                            this.generatedPassword = response.body.Data.GeneratedPassword;
                            this.generatedPasswordUser = userEmail;
                            this.$refs.mdlShowGeneratedPassword.show();
                        } else {
                            this.$toasted.show(this.$t('PasswordResetSuccessNotice'), { theme: 'outline', type: 'success', duration: 5000 });
                        }
                    }
                    else {
                        this.$toasted.show(response.body.Message || this.$t('UpdatingRegistryError'), { theme: 'outline', type: 'error', duration: 5000 });
                    }
                } catch (e) {
                    var response = e;
                    if (!response.body.Ok) {
                        var errMsg = response.data && response.data.Data ? response.data.Data.Message : (response.body && response.body.Message ? response.body.Message : '');
                        this.$toasted.show(this.$t('UpdatingRegistryError') + " " + errMsg, { theme: 'outline', type: 'warning', duration: 8000 });
                    }
                }
                this.loading = false;
            },
            async onBulkResetConfirm() {
                if (this.selectedUserIds.length === 0) return;
                
                let confirmMsg = `¿Confirma forzar el cambio de contraseña para los ${this.selectedUserIds.length} usuarios seleccionados? Los usuarios mantendrán su clave actual y se les exigirá cambiarla obligatoriamente en su próximo inicio de sesión.`;
                let confirmed = await this.$refs.ConfirmDialog.ShowConfirmation(confirmMsg).catch(() => false);
                
                if (confirmed) {
                    this.loading = true;
                    try {
                        let response = await this.$http.post('/api/users/bulkresetpassword', { userIds: this.selectedUserIds });
                        if (response.body.Ok) {
                            let resetCount = response.body.Data.ResetCount;
                            this.$toasted.show(`Se forzó el cambio de contraseña para ${resetCount} usuario(s) en su próximo inicio de sesión.`, { theme: 'outline', type: 'success', duration: 6000 });
                            this.selectedUserIds = [];
                            this.allSelected = false;
                            this.loadData();
                        } else {
                            this.$toasted.show(response.body.Message || this.$t('UpdatingRegistryError'), { theme: 'outline', type: 'error', duration: 6000 });
                        }
                    } catch (e) {
                        this.$toasted.show(this.$t('UpdatingRegistryError'), { theme: 'outline', type: 'error', duration: 6000 });
                    }
                    this.loading = false;
                }
            },
            onEdit(item, index, target) {
                this.selectedItem.Id = item.id;
                this.selectedItem.Nombre = item.nombre;
                this.selectedItem.Email = item.email;
                this.selectedItem.Ref_Rol = item.ref_rol;
                this.selectedItem.Ref_Pais = item.ref_pais;
                this.selectedItem.bloqueado = item.bloqueado;
                this.selectedItem.borrar_archivos = item.borrar_archivos;
                this.selectedItem.global_gap_token = item.global_gap_token;
                this.selectedItem.vs_usuario = item.vs_usuario;
                this.selectedItem.vs_contrasena = item.vs_contrasena;
                this.$refs.mdlUsers.show();
            },
            onResetPwd(item, index, target) {
                this.selectedItem.Id = item.id;
                this.selectedItem.Nombre = item.nombre;
                this.selectedItem.Email = item.email;
                this.selectedItem.Ref_Rol = item.ref_rol;
                this.selectedItem.Ref_Pais = item.ref_pais;
                this.selectedItem.global_gap_token = item.global_gap_token;
                this.selectedItem.vs_usuario = item.vs_usuario;
                this.selectedItem.vs_contrasena = item.vs_contrasena;
                this.$refs.mdlResetPwd.show();
            },
            onVs(item, index, target) {
                this.selectedItem.Id = item.id;
                this.selectedItem.vs_usuario = item.vs_usuario;
                this.selectedItem.vs_contrasena = '';
                this.$refs.mdlVs.show();
            },            
            async onDelete(item, index, target) {
                var self = this;
                let resConfirmation = await self.$refs.ConfirmDialog.ShowConfirmation(this.$t('DeleteRecordConfirm')).catch((ex) => { console.log(ex); });
                if (resConfirmation) {
                    try {
                    this.loading = true;
                    var response = await this.$http.post('/api/users/delete', item);
                    if (response.body.Ok) {
                        this.$toasted.show(this.$t('RegistrationUpdatedSuccessfully'), { theme: 'outline', type: 'success', duration: 5000 });
                        this.loadData();
                    }
                    else {
                        this.$toasted.show(this.$t('UpdatingRegistryError'), { theme: 'outline', type: 'error', duration: 5000 });
                    }
                } catch (e) {
                        var response = e;
                        if (!response.body.Ok) {
                            this.$toasted.show(this.$t('CantDeleteUser'), { theme: 'outline', type: 'error', duration: 5000 });
                        }
                }
                }
                this.loading = false;
            },
            validEmail: function (email) {
                if (email == null) return false;
                var re = /(.+)@(.+){2,}\.(.+){2,}/;
                return re.test(email.toLowerCase());
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>
